import angular from 'angular';
import categoryForm from './category-form.component';

export default angular.module('components.admin.categories.categoryForm', [])
  .component('categoryForm', categoryForm)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/categories/category-form/category-form.module.js